import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private appScreenWidth$: Observable<number>;

  constructor() {
    this.appScreenWidth$ = fromEvent(window, 'resize').pipe(
      map(() => window.innerWidth),
      distinctUntilChanged(),
      startWith(window.innerWidth),
      shareReplay(1)
    );
  }

  selectScreenWidth(): Observable<number> {
    return this.appScreenWidth$;
  }
}
